var t={button:"button-styles-module_button__7ZvnT",outline:"button-styles-module_outline__9SSkg"};export{t as default};
//# sourceMappingURL=button.styles.module.scss.js.map
